import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_account_entitlement_employee_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    claim_entitlement_code: fromDatatype.VarcharDatatypeInterface;
    claim_entitlement_guid: fromDatatype.GuidDataFieldInterface;
    claim_entitlement_code_error: fromDatatype.VarcharDatatypeInterface;
    employee_code: fromDatatype.VarcharDatatypeInterface;
    employee_guid: fromDatatype.GuidDataFieldInterface;
    employee_code_error: fromDatatype.VarcharDatatypeInterface;
    topup_amount: fromDatatype.NumericDatatypeInterface;
    topup_amount_error: fromDatatype.VarcharDatatypeInterface;
    start_date: fromDatatype.VarcharDatatypeInterface;
    end_date: fromDatatype.VarcharDatatypeInterface;
    line_no: fromDatatype.IntegerDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_account_entitlement_employee_import_file_helper_RowClass implements bl_aat_claim_account_entitlement_employee_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    claim_entitlement_code: fromDatatype.VarcharDatatypeInterface;
    claim_entitlement_guid: fromDatatype.GuidDataFieldInterface;
    claim_entitlement_code_error: fromDatatype.VarcharDatatypeInterface;
    employee_code: fromDatatype.VarcharDatatypeInterface;
    employee_guid: fromDatatype.GuidDataFieldInterface;
    employee_code_error: fromDatatype.VarcharDatatypeInterface;
    topup_amount: fromDatatype.NumericDatatypeInterface;
    topup_amount_error: fromDatatype.VarcharDatatypeInterface;
    start_date: fromDatatype.VarcharDatatypeInterface;
    end_date: fromDatatype.VarcharDatatypeInterface;
    line_no: fromDatatype.IntegerDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}